/**
 * 思考过程管理 Composable
 * 记录和管理 AI 的真实思考步骤（用于 UI 展示）
 * 
 * Vercel AI SDK 的 streamText API 自动捕获，包括：初始思考、工具调用、继续生成等步骤，通过 onStepFinish 和 onFinish 回调获取
 * 
 * 新消息生成完成	setThinkingSteps()	加载当前AI回复的思考步骤
 * 重新生成	clearThinkingSteps()	清空旧的思考步骤
 * 编辑消息	clearThinkingSteps()	清空旧的思考步骤
 * 删除消息	clearThinkingSteps()	清空相关的思考步骤
 * 
 * 位置	用途	生命周期
  后端缓存 (steps-cache.ts)	；临时存储，供前端查询；会话期间有效
  数据库 (messages.thinkingSteps)	；持久化存储；永久保存
  前端状态 (thinkingSteps ref)；实时展示；页面刷新后丢失
  消息对象 (message.thinkingSteps)	；历史消息携带；随消息持久化

 */

import { ref } from "vue";

export interface ThinkingStep {
  id?: string;
  icon: string;
  text: string;
  timestamp: number;
  status?: "pending" | "completed" | "error";
  stepType?: "initial" | "tool-result" | "continue";
  result?: any; // 工具执行结果
}

export function useThinkingProcess() {
  // 当前消息的思考步骤
  const thinkingSteps = ref<ThinkingStep[]>([]);

  /**
   * 批量设置思考步骤（从后端接收的真实数据）
   */
  const setThinkingSteps = (steps: ThinkingStep[]) => {
    thinkingSteps.value = steps.map((step) => ({
      ...step,
      timestamp: step.timestamp || Date.now(),
      status: step.status || "completed",
    }));

    console.log("📊 设置真实思考步骤:", steps.length, "步");
  };

  /**
   * 清空思考步骤
   */
  const clearThinkingSteps = () => {
    thinkingSteps.value = [];
  };

  /**
   * 获取思考步骤数量
   */
  const getThinkingStepsCount = () => {
    return thinkingSteps.value.length;
  };

  return {
    thinkingSteps,
    setThinkingSteps, // 批量设置步骤（唯一入口）
    clearThinkingSteps,
    getThinkingStepsCount,
  };
}
